import type { I18n } from '@learnforge/i18n';
import type { AlgebraKey } from './locales/keys';

export interface ActionDef {
  id: string;
  labelKey: AlgebraKey;
  onClick(): void;
  disabled?: boolean;
}

export interface ActionBarHandle {
  setActions(actions: readonly ActionDef[]): void;
  clear(): void;
}

export function mountActionBar(host: HTMLElement, i18n: I18n<AlgebraKey>): ActionBarHandle {
  let currentActions: readonly ActionDef[] = [];
  let unsubscribe: (() => void) | null = null;

  const render = (actions: readonly ActionDef[]): void => {
    host.replaceChildren();
    for (const action of actions) {
      const btn = document.createElement('button');
      btn.className = 'alg-actionbar-btn';
      btn.textContent = i18n.t(action.labelKey);
      btn.dataset.actionId = action.id;
      if (action.disabled) btn.disabled = true;
      btn.addEventListener('click', () => action.onClick());
      host.appendChild(btn);
    }
  };

  return {
    setActions(actions) {
      currentActions = actions;
      render(actions);

      // Clean up previous subscription if it exists
      if (unsubscribe) {
        unsubscribe();
      }

      // Subscribe to language changes to re-render labels
      unsubscribe = i18n.subscribe(() => {
        render(currentActions);
      });
    },
    clear() {
      currentActions = [];
      host.replaceChildren();
      if (unsubscribe) {
        unsubscribe();
        unsubscribe = null;
      }
    },
  };
}
